import {
  AiDebugProcess,
  AiReply,
  AuthorRole,
  DialogueSnapshot,
  Message,
} from 'lib/apiClient'

import { MessageGroup, MessageGroupType, StackMessage } from '../../../types'

function isSameDay(t1: string, t2: string) {
  const d1 = new Date(t1)
  const d2 = new Date(t2)

  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  )
}

function isSameTimeGap(t1: string, t2: string) {
  const d1 = new Date(t1)
  const d2 = new Date(t2)

  return Math.abs(d1.getTime() - d2.getTime()) <= 60_000
}

function getAiMessage(messageId: string, aiReply: AiReply): StackMessage {
  return {
    debug: true,
    messageId,
    authorRole: AuthorRole.Agent,
    created: aiReply.timestamp,
    authorName: aiReply.author,
    text: aiReply.text,
  }
}

export function mapDialogueSnapshot(
  snapshotMessages: DialogueSnapshot['messages'],
  aiDebugProcess: AiDebugProcess,
): MessageGroup[] {
  const result: MessageGroup[] = []

  let currentMessage: Message | null = null
  let messageStack: StackMessage[] = []

  const resetStack = () => {
    if (!messageStack.length) {
      return
    }

    result.push({
      type: MessageGroupType.Stack,
      messages: messageStack,
    })

    messageStack = []
  }

  const snapshotWithAiMessage = [...snapshotMessages]

  if (aiDebugProcess.reply) {
    snapshotWithAiMessage.push(getAiMessage(aiDebugProcess.id, aiDebugProcess.reply))
  }

  for (const message of snapshotWithAiMessage) {
    const splitByDay =
      !currentMessage || !isSameDay(message.created, currentMessage.created)
    const splitByTimeGap =
      currentMessage && !isSameTimeGap(message.created, currentMessage.created)
    const splitByAuthorRole =
      currentMessage && currentMessage.authorRole !== message.authorRole
    const splitByAuthorName =
      currentMessage?.authorName && currentMessage.authorName !== message.authorName

    if (splitByDay || splitByAuthorRole || splitByTimeGap || splitByAuthorName) {
      resetStack()
    }

    if (splitByDay) {
      result.push({
        type: MessageGroupType.Date,
        timestamp: message.created,
      })
    }

    currentMessage = message
    messageStack.push(message)
  }

  resetStack()

  return result
}
